import React from 'react';
import { useSelector } from 'react-redux';
import Loader from '../../features/common/Loader/Loader';
import TableHeader from '../data-tables/TableHeader';
import EspWidgetTable from './EspWidgetTable';
import { RootState } from '../../store';

interface GenericEspWidgetProps {
  title: string;
  rowsConfig: any[][];
  wellTestDetails?: boolean;
}

const GenericEspWidget: React.FC<GenericEspWidgetProps> = ({ title, rowsConfig, wellTestDetails = true }) => {
  const latestAssetTrendData = useSelector((state: RootState) => state.LatestAssetTrendData.data) || [];
  const isLoading = useSelector((state: RootState) => state.LatestAssetTrendData.loading);

  return (
    <main className='main-container table-wrap'>
      <TableHeader title={title} wellTestDetails={wellTestDetails} />
      {isLoading ? (
        <div className='flex justify-center items-center h-[70%]'>
          <Loader />
        </div>
      ) : latestAssetTrendData.length > 0 ? (
        <EspWidgetTable data={latestAssetTrendData} rowsConfig={rowsConfig} />
      ) : (
        <div className='flex justify-center items-center h-[70%]'>
          <span>No records found</span>
        </div>
      )}
    </main>
  );
};

export default GenericEspWidget;
